import { Button } from 'flowbite-react';
import React from 'react';
import { useGetMeetingRecordingByMeetingIdQuery } from 'src/hooks/meeting.hooks';
import { GetMeetingScoreCardAPIResponse, MeetingStatus } from 'types';
import OverallRoundScore from './OverallRoundScore';

interface Props {
	status: MeetingStatus | undefined;
	handleViewRecording: () => void;
	meetingId: string;
	meetingScore: number;
	skillScores: GetMeetingScoreCardAPIResponse['allMeetingSkillScores'];
}

const StatusAndRecording = ({ status, handleViewRecording, meetingId, meetingScore, skillScores }: Props) => {
	const { data, isLoading } = useGetMeetingRecordingByMeetingIdQuery(meetingId);

	return (
		<div className="flex justify-between items-center">
			<div>
				<div>Status</div>
				<div className="px-[10px] py-[2px] bg-gray-50 dark:bg-[#374151] border border-solid border-[#31C48D] text-[#31C48D] rounded-[6px] mt-2">
					{status ?? 'Completed'}
				</div>
			</div>
			{data?.recordings?.length ? (
				<div>
					<Button onClick={handleViewRecording} color="light">
						View Recording
					</Button>
				</div>
			) : !skillScores?.length ? (
				<OverallRoundScore score={meetingScore} />
			) : null}
		</div>
	);
};

export default StatusAndRecording;
